export const THEMES_CONFIG = {
  default: 'Default Theme',
  dark: 'Dark Mode',
};
